import { FC, ReactNode } from 'react';
import { trackFooterNavigationClick } from '../../helpers/trackingHelpers';

type Props = {
    trackingLabel: string;
    serverRenderedChildren: ReactNode;
};

const FooterTrackingWrapper: FC<Props> = ({ trackingLabel, serverRenderedChildren }) => (
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions,jsx-a11y/click-events-have-key-events
    <span
        onClick={event => {
            trackFooterNavigationClick({ label: trackingLabel }, event);
        }}
    >
        {serverRenderedChildren}
    </span>
);

export default FooterTrackingWrapper;
